import ResourceManager, { ResourceType } from "../../components/ResourceManager/ResourceManager"
import { useTodoMutations } from "../hooks/use-todo-mutations"
import { useI18n } from "../../hooks/use-i18n"
import { StringMap } from "../../types/common"
import { TodoViewModel } from "../api/todo"
import { TodoTaskResponse } from "../api/todo-response"

const TodoTaskWidget = ({ todo, taskOptions, isTaskLoading }: TodoTaskWidgetProps) => {
  const { updateTask } = useTodoMutations()
  const translations = useTranslations(defaultTranslations)

  const taskResource: ResourceType[] = todo.task ? [{ id: todo.task.id, name: todo.task.title }] : []

  const onAddTask = (taskId: string) => {
    const task = taskOptions.find((t) => t.id === taskId)
    if (!task) return
    updateTask(todo.id, { task: { id: task.id, title: task.name } as TodoTaskResponse })
  }

  const onRemoveTask = () => {
    updateTask(todo.id, { task: null })
  }

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={taskOptions}
      resources={taskResource}
      canAddResource={todo.canUpdate && !isTaskLoading}
      canRemoveResource={todo.canUpdate && !isTaskLoading}
      onAddResource={onAddTask}
      onRemoveResource={onRemoveTask}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection={false}
    />
  )
}

const useTranslations = (defaults = defaultTranslations) => {
  const { translations: t } = useI18n("todo")
  const translations = (t?.taskWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Task",
  emptyOptionsMessage: "No tasks to connect this todo",
  emptyResourcesMessage: "This todo is not connected to any task",
  updateErrorMessage: "Failed to update task",
}

type TodoTaskWidgetProps = {
  todo: TodoViewModel
  taskOptions: ResourceType[]
  isTaskLoading?: boolean
}

export default TodoTaskWidget
